import _ from 'lodash';
import React from 'react';
import Promise from 'bluebird';


import Api from '../../api';
import component, {classnames, navigateTo, makePath} from '../component';
import routes from '../../routes';
import TopBanner from '../TopBanner';
import TopHeader from '../TopHeader';
import SubNav from '../SubNav';
import SearchBar from '../SearchBar';
import TopActionButtons from '../TopActionButtons';
import DataEditButton from '../DataEditButton';
import LoadMoreButton from '../LoadMoreButton';
import {Table, Tr, Th, Td} from '../Table';
import {HBox, VBox} from '../Box';
import Link from '../Link';
import Flag from '../Flag';
import {TableListRow, TableListCell} from '../TableList';
import {Caution} from './../icons';

import League from './../League';

import notices from './../notices';

export default component('Teams', function({data, params, query}) {

  const subNav = data.getIn(['nav'])
      .find(x => x.get('name') === 'teams')
      .get('children');

  const submit = () => {
    navigateTo(makePath('teams', params, query));
  };

  function createTeam() {
    navigateTo(makePath('teamsNew'));
  }

  async function loadMore() {
    data.setIn(['teams', 'loading'], true);
    await Api.teams(data, params, query);
    data.setIn(['teams', 'loading'], false);
  }

  const qPath = ['route', 'query', 'query'];
  if (!data.getIn(qPath)) {
    data.setIn(qPath, '');
  }

  const sb = <SearchBar data={data.cursor(qPath)}
                        placeholder='Найти команду' onSubmit={submit} />;

  const btnMore = data.getIn(['teams', 'noMore'])
      ? null
      : <LoadMoreButton text='команд' onClick={loadMore}
                        loading={data.getIn(['teams', 'loading'])} />;

  const applyToTeam = async function(team) {
    if( !data.get('user') ){
      data.cursor('popup').set({
        icon: Caution,
        message: notices.authBeforeJoiningTeam,
        action: 'Ok',
        iconWidth: 128,
        iconHeight: 128,
        autoClose: true
      });
      return false;
    }
    if( data.getIn(['user', 'has_team']) ){
      data.cursor('popup').set({
        icon: Caution,
        message: notices.haveTeamAlready,
        action: 'Ok',
        iconWidth: 128,
        iconHeight: 128,
        autoClose: true
      });
      return false;
    }

    team.setIn('application_sent', true);
    await Api.teamApply({teamId: team.get('id')});
  };

  const applyToTeamCancel = async function(team) {
    team.setIn('application_sent', false);
    await Api.teamApplyCancel({teamId: team.get('id')});
  };

  function errorAuth() {
    data.cursor('popup').set({
      icon: Caution,
      message: notices.authBeforeCreatingTeam,
      action: 'Ok',
      iconWidth: 128,
      iconHeight: 128,
      autoClose: true
    })
  }

  function quitTeamFirst(){
    data.cursor('popup').set({
      icon: Caution,
      message: notices.leaveTeamBeforeCreatingTeam,
      action: 'Ok',
      iconWidth: 128,
      iconHeight: 128,
      autoClose: true
    })
  }

  return (
    <div>
      <TopBanner size='small' align={false}>

          <TopActionButtons>
            {
              data.cursor('user').hasData()
                ?
                <div>
                  {!data.getIn(['user', 'has_team']) &&
                    <Link name='teamsNew'>
                      <DataEditButton text='Создать команду' />
                    </Link> ||
                  <DataEditButton onClick={quitTeamFirst} text='Создать команду' />
                  }
                </div>
                :
                <div>
                  <DataEditButton onClick={errorAuth} text='Создать команду' />
                </div>
            }
          </TopActionButtons>

        <TopHeader left>Команды</TopHeader>
        <SubNav data={subNav} params={params} query={query} defaultQuery={{sort: '-score'}}
                label='Сортировать по' SearchBar={sb} />
      </TopBanner>
      <VBox width={4} isContainer className='TeamList'>
        {
          data.cursor(['teams', 'list']).hasData() ?
            data.cursor(['teams', 'list']).map((team) => {
              const itemImage = team.get('image');
              const bgImage = itemImage
                  ? itemImage + '?crop=1&w=104&h=104'
                  : require('../../img/teamEmptyAvatarSquare.png');
              return <TableListRow key={team.get('id')} height={104}>
                <TableListCell width={104} type='Logo'>
                  <Link name='teamDetails' className="TableListCell-Avatar"  params={{id: team.get('id')}} style={{
                    backgroundImage: `url(${bgImage})`,
                    width: 104,
                    height: 104
                  }} />
                </TableListCell>
                <TableListCell width={632} type='Primary'>
                  <div className='TeamList-TeamInfo'>
                    <div className='TeamList-TeamTitleCountry'>
                      <div className='TeamList-TeamTitle'>
                        <Link name='teamDetails' params={{id: team.get('id')}}>
                          {team.get('title')}
                        </Link>
                        <League className="League--inList" league={team.get('league')}/>
                      </div>
                      <div className='TeamList-TeamCountry'><Flag country={team.get('country')} outputName /></div>
                    </div>

                    <div className='TeamList-TeamApplication'>
                      {!team.get('is_full') &&
                        (
                          team.get('application_sent') ?
                            <div className="TeamList-ApplicationWrapper">
                              <div className="TableListCell-InvitationSent">Заявка отправлена</div>
                              <DataEditButton text='Отменить' backgroundType='light' onClick={applyToTeamCancel.bind(this, team)} />
                            </div> :
                            <div className="TeamList-ApplicationWrapper">
                              <DataEditButton text='Подать заявку'applyToTeamCancel
                                          onClick={applyToTeam.bind(this, team)}
                                          backgroundType='light' />
                            </div>
                        )
                      }
                    </div>
                  </div>
                </TableListCell>
                <TableListCell width={128} type='Secondary' header='Матчей'>{team.get('total_games')}</TableListCell>
                <TableListCell width={128} type='Secondary' header='Побед'>{team.get('won_games')}</TableListCell>
                <TableListCell width={128} type='Secondary' header='Поражений'>{team.get('lost_games')}</TableListCell>
                <TableListCell width={128} type='Secondary' header='Очки'>{team.get('score')}</TableListCell>
              </TableListRow>
            })
          :
            <div className="Content-NoFound">
              Ничего не найдено
            </div>
        }

        {btnMore}
      </VBox>
    </div>
  );
});



// WEBPACK FOOTER //
// ./src/components/pages/Teams.js